import { Component, Inject, Input, ViewChild, OnInit } from '@angular/core'
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog'
import { BarcodeFormat, Result } from '@zxing/library'
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

interface DialogData {
  scanParseFn: Function
}

@Component({
  selector: 'app-scan-tag-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, TranslateModule, ZXingScannerModule],
  templateUrl: './scan-tag-dialog.component.html',
  styleUrls: ['./scan-tag-dialog.component.scss'],
})
export class ScanTagDialogComponent implements OnInit {
  @ViewChild('scanner', { static: false })
  scanner!: ZXingScannerComponent

  public hasNoCamera: boolean = false
  public devices!: MediaDeviceInfo[]
  public formatsEnabled: BarcodeFormat[] = [
     BarcodeFormat.CODE_128,
    // BarcodeFormat.DATA_MATRIX,
     BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ]

  private _deviceIndex: number = 0

  constructor(
    private _dialogRef: MatDialogRef<ScanTagDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {}

  onScan(event: string) {
    // On parse et on checke la valeur scannée
    const taguid = this.parseScan(event)

    // Si valeur parsée avec success
    // On la retourne et on ferme la modale
    if (taguid) {
      this._dialogRef.close(taguid)
    }
  }

  onScanComplete(_event: Result) {
    // console.log('SCAN COMPLETE', event)
  }

  onCamerasFound(devices: MediaDeviceInfo[]) {
    this.devices = devices
  }

  onSwitchDevice() {
    this.scanner.device = this.devices[this._deviceIndex ? 0 : 1]
  }

  onCamerasNotFound() {
    this.hasNoCamera = true
  }

  parseScan(value: string): string {
    if (this.data?.scanParseFn) {
      return this.data.scanParseFn(value)
    }
    return value
  }
}
